import * as React from 'react';
import { useEffect, useRef } from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Mousewheel, FreeMode } from 'swiper';
import FancyTitle from './fancy-title';
// eslint-disable-next-line import/no-unresolved
import 'swiper/css/pagination';

function SplitPaneJobs({
  left, right, flip, className, items = 'center', leftWidth = 'xl:w-1/3', rightWidth = '',
}) {
  return (
    <div className={`flex flex-wrap lg:flex-nowrap ${className}`}>
      <div className={`w-full flex justify-left xl:justify-end xl:absolute z-10 pointer-events-none top-0 right-0 left-0 bottom-0 bg-white items-${items}${leftWidth && ` ${leftWidth}`}`}>
        {left}
      </div>
      <div className={`w-full ${flip ? ' lg:-order-1' : ''}${rightWidth && ` ${rightWidth}`}`}>
        {right}
      </div>
    </div>
  );
}

function SplitSlider({
  data,
  title,
  subtitle,
  imageClasses,
}) {
  const splitSliderRef = useRef(null);

  const getHeight = (element) => {
    const subtitleMobileHeight = document.querySelectorAll(element);
    let maxHeight = 0;

    for (let i = 0; i < subtitleMobileHeight.length; i++) {
      subtitleMobileHeight[i].style = 'height: max-content';
    }

    for (let i = 0; i < subtitleMobileHeight.length; i++) {
      if (subtitleMobileHeight[i].offsetHeight > maxHeight) {
        maxHeight = subtitleMobileHeight[i].offsetHeight;
      }
    }

    for (let i = 0; i < subtitleMobileHeight.length; i++) {
      subtitleMobileHeight[i].style = `height: ${maxHeight}px`;
    }
  };

  useEffect(() => {
    const paddingHeightForState = (screen.height - splitSliderRef.current.offsetHeight) / 2;
    const root = document.querySelector(':root');
    root.style.setProperty('--JobSliderTop', `${paddingHeightForState}px`);
  }, [splitSliderRef]);

  return (
    <div className="sticky top-[var(--JobSliderTop)]" ref={splitSliderRef}>
      <SplitPaneJobs
        className="mb-24 mt-12 items-center lg:!flex-wrap xl:!flex-nowrap relative"
        right={(
          <Swiper
            modules={[Pagination, Mousewheel, FreeMode]}
            direction="horizontal"
            slidesPerView={1}
            className="lg:h-[800px] scroll-smooth"
            pagination={{ clickable: true }}
            mousewheel={false}
            freeMode={false}
            autoHeight
            onBeforeInit={() => getHeight('.slider-item')}
            onResize={() => getHeight('.slider-item')}
            breakpoints={{
              1023: {
                direction: 'vertical',
                pagination: {
                  enabled: false,
                },
                mousewheel: {
                  enabled: true,
                  releaseOnEdges: true,
                },
                freeMode: {
                  enabled: true,
                },
                autoHeight: false,
              },
            }}
          >
            {data.map((item) => {
              const imageLight = getImage(item.imageLight);

              return (
                <SwiperSlide
                  key={item.title}
                  className={`flex align-center justify-center flex-row bg-background-light dark:bg-latori-gray p-0${
                    data.length > 1 ? 'cursor-grab' : ''
                  }`}
                >
                  <div className="xl:w-1/3 shrink-0" />
                  <div className="flex flex-col align-center justify-center text-center w-full xl:p-0 p-6">

                    <div>
                      {item.image && (
                        <img
                          src={item.image.filename}
                          width="80"
                          height="80"
                          alt={item.title}
                          loading="lazy"
                          className="object-cover rounded-full w-24 mb-5 mx-auto"
                        />
                      )}
                      {imageLight && (
                        <GatsbyImage
                          image={imageLight}
                          className="dark:hidden object-cover w-24 mb-5 rounded-full"
                          alt={item.title}
                          style={{
                            width: item.imageWidth || '',
                            height: item.imageWidth ? 'auto"' : '',
                          }}
                        />
                      )}
                    </div>
                    <FancyTitle
                      fontSize="20"
                      marginBottom="mb-5"
                      text={item.title}
                      className="text-center"
                      tag={item.subtitle ? 'h4' : 'h3'}
                    />
                    <div className="text-center max-w-xl ml-auto mr-auto pb-6">
                      {item.subtitle && (
                        <p className="dark:prose-invert mb-[20px]">
                          {item.subtitle}
                        </p>
                      )}
                      <p
                        className="dark:prose-invert slider-item"
                        dangerouslySetInnerHTML={{
                          __html: item.description?.content[0]?.content[0]?.text
                        }}
                      />
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        )}
        left={(
          <div className="w-full flex lg:pr-8 justify-center lg:justify-normal">
            <FancyTitle
              tag="h2"
              text={title}
              subtitle={subtitle}
              textAlign="text-center xl:text-right"
              lineHeight="!leading-[1.333]"
            />
          </div>
        )}
        flip={false}
      />
    </div>
  );
}

export default SplitSlider;
